import React from 'react';
import { useIsAuthenticated } from 'react-auth-kit';
import { useSignOut } from 'react-auth-kit';
import { useAuthUser } from 'react-auth-kit';
import { useNavigate, Link } from 'react-router-dom';
import { Box, Button, IconButton, Typography } from '@mui/material';

const Navbarespaceperso = () => {
    const isAuthenticated = useIsAuthenticated();
    const signOut = useSignOut();
    const authUser = useAuthUser();
    const navigate = useNavigate();

    const handleSignOut = () => {
        signOut();
        navigate('/');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: 'transparent',
                position: 'absolute',
                width: '100%',
                marginTop:'1rem'
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'center', flexGrow: 1 }}>
                
                

                <Link to="/Infospratiques" style={{ textDecoration: 'none' }}>
                    <Typography
                        sx={{
                            margin: '0 15px',
                            color: 'transparent',
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                        }}
                    >
                        Infos pratiques
                    </Typography>
                </Link>
                <Link to="/Contact" style={{ textDecoration: 'none' }}>
                    <Typography
                        sx={{
                            margin: '0 15px',
                            color: 'transparent',
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                        }}
                    > Contact                    
                    </Typography>
                </Link>

                {isAuthenticated() ? (
                    authUser() && authUser().role === 'admin' ? (
                        <Link to="/Espace_Admin" style={{ textDecoration: 'none' }}>
                            <Typography
                                sx={{
                                    margin: '0 15px',
                                    color: 'transparent',
                                    textTransform: 'uppercase',
                                    fontWeight: 'bold',
                                }}
                            >
                                Espace Admin
                            </Typography>
                        </Link>
                    ) : (
                        <Link to="/Espace_Perso" style={{ textDecoration: 'none' }}>
                    <Typography
                        sx={{
                            margin: '0 15px',
                            color: 'white',
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                        }}
                    >
                        ESPACE PERSO
                    </Typography>
                </Link>
                    )
                ) : null}
            </Box>
            <Box>
                {isAuthenticated() ? (
                    <Button
                        sx={{
                            backgroundColor: '#96013C',
                            color: 'white',
                            padding: '10px 15px',
                            borderRadius: '20px',
                            fontWeight: 'bold',
                            marginRight:'5rem',
                            marginTop:'1rem',
                            '&:hover': {
                                backgroundColor: '#96013C',
                            },
                        }}
                        onClick={handleSignOut}
                    >
                        DECONNEXION
                    </Button>
                ) : (
                    <Link to="/Login" style={{ textDecoration: 'none' }}>
                        <Button  sx={{
                            backgroundColor: 'white',
                            color: 'black',
                            padding: '10px 30px',
                            borderRadius: '20px',
                            fontWeight: 'bold',
                            marginRight:'5rem',
                            '&:hover': {
                                backgroundColor: 'white',
                            },
                        }}>
                            CONNEXION
                        </Button>
                    </Link>
                )}
            </Box>
        </Box>
    );
};

export default Navbarespaceperso;
